<template>
  <div>
    <div>
      <div class="flex flex-h-end mt-20">
        <router-link
          class="move-right mt-20 pointer no-line"
          to="/admin/attendance/overtime/settings"
        >
          <div class="settings-bg">
            <img src="/img/settings-b.svg" alt="" /> <span>Settings</span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="relative  adjust-height">
      <div class="white-bg relative">
        <div :class="{ overlay: true, show: view }"></div>
        <div class="table-heading flex flex-v-center flex-h-bet">
          <div class="flex">
            <div class="media-group flex filter-label  p-0">
              <div class="filter"><p class="ml-10">Filters:</p></div>
              <el-date-picker
                v-model="filterDate"
                type="daterange"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date"
                @change="getOvertimes"
              >
              </el-date-picker>
            </div>

            <el-select
              v-model="filterStatus"
              placeholder="All Status"
              class="filter-select ml-10"
              clearable
              @change="getOvertimes"
            >
              <el-option
                v-for="item in statueOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="flex">
            <transition name="fade" mode="out-in">
              <div v-if="showDeleteButton" class="mt-10">
                <span class="success line">Approve</span>
                <span class="danger line ml-10 mr-10">Reject</span>
              </div>
            </transition>
            <div class="relative">
              <img
                src="/img/search-icon.svg"
                alt="search team table"
                class="search-icon"
              />
              <el-input
                placeholder="Search"
                name="search"
                type="text"
                class="short mr-10"
                v-model="filterValue"
                @input="search"
                clearable
              ></el-input>
            </div>
          </div>
        </div>

        <AllOvertimeTable
          class="mt-20"
          @handleSelectionChange="handleSelectionChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AllOvertimeTable from "../components/AllOvertimeTable";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("admin/attendance/overtime");

import debounce from "lodash.debounce";

export default {
  components: {
    AllOvertimeTable,
  },
  data() {
    return {
      multipleSelection: [],
      view: false,
      searchQuery: "",
      statueOptions: [
        {
          label: "Pending",
          value: "pending",
        },
        {
          label: "Approved",
          value: "approved",
        },
        {
          label: "Rejected",
          value: "rejected",
        },
      ],
    };
  },
  computed: {
    showDeleteButton() {
      return this.multipleSelection.length > 1;
    },
    filterDate: {
      set(value) {
        this.$store.commit("admin/attendance/overtime/OVERTIME_MUTATIONS", {
          key: "overtimeDate",
          value,
        });
      },
      get() {
        return this.$store.state.admin.attendance.overtime.overtimeDate;
      },
    },
    filterValue: {
      set(value) {
        this.$store.commit("admin/attendance/overtime/OVERTIME_MUTATIONS", {
          key: "overtimeSearch",
          value,
        });
      },
      get() {
        return this.$store.state.admin.attendance.overtime.overtimeSearch;
      },
    },
    filterStatus: {
      set(value) {
        this.$store.commit("admin/attendance/overtime/OVERTIME_MUTATIONS", {
          key: "overtimeFilter",
          value,
        });
      },
      get() {
        return this.$store.state.admin.attendance.overtime.overtimeFilter;
      },
    },
  },
  mounted() {
    this.getOvertimes();
  },
  methods: {
    ...mapActions(["getOvertimes"]),
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    search: debounce(function() {
      this.getOvertimes();
    }, 500),
  },
};
</script>

<style></style>
